<template>

  <section class="info-list component-container">
    <div class="info-panel-box">
      <div class="info-panel">
        <div class="container-head contain-btn-title">
          <div class="container-head-title">
            <i class="icon-laba iconfont"style="color: #f3a954;font-size: 30px"></i>
            <span class="subpage-head-text" style="margin-top: -5px;position: absolute;padding-left: 5px;">{{title}}</span>
            <div style="float: right">
              <common-button size="default" type="cancel" image @click="handleBackClick()">返回</common-button>
            </div>
          </div>
        </div>

        <div class="container-body">
          <el-row>
            <div style="float: right">
              <common-button v-if="this.editFlag" size="small" type="cancel" image @click="bulkImport" style="margin-left: 5px">批量导入</common-button>
              <common-button v-if="this.editFlag" size="small" type="cancel" slot="expand" @click="templateDown('/static/files/Zhuanke_FileUpload.xlsx')" style="margin-left: 5px">模板下载</common-button>
            </div>
          </el-row>
          <div class="form-body">
            <div class="info-list-table-card">
              <el-form :model="zhuankeForm" :rules="zhuankeRules" ref="ruleForm">
                <el-table
                  ref="table"
                  v-loading="tableData.isLoading"
                  :data="tableData.list"
                  tooltip-effect="dark"
                  highlight-current-row
                  size="mini"
                  style="width: 100%;">
                  <el-table-column align="center" label="序号" width="50">
                    <template slot-scope="scope">
                      <div class="index">{{ scope.$index + 1 }}</div>
                    </template>
                  </el-table-column>

                  <el-table-column label="名称" min-width="200">
                    <template slot-scope="scope">
                      <el-form-item :style="{'margin-bottom': scope.$index == globalIndex ? '23px': '0px'}" prop="title">
                        <el-input
                          v-if="scope.$index == globalIndex"
                          v-model="zhuankeForm.title"
                          clearable
                          placeholder="请输入">
                        </el-input>
                        <span v-else class="twoLineCls" :title="scope.row.title">{{ scope.row.title }}</span>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column label="获得时间" :min-width="globalIndex!=null?160:100">
                    <template slot-scope="scope">
                      <el-form-item :style="{'margin-bottom': scope.$index == globalIndex ? '23px': '0px'}" prop="beginDate">
                        <el-date-picker
                          v-if="scope.$index == globalIndex"
                          type="date"
                          v-model="zhuankeForm.beginDate"
                          :picker-options="startPickerOptions"
                          clearable
                          style="width: 100%"
                          placeholder="请选择">
                        </el-date-picker>
                        <span v-else class="twoLineCls">{{ scope.row.beginDate | dateFormat}}</span>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column :min-width="globalIndex!=null?120:100" label="单位性质" >
                    <template slot-scope="scope">
                      <el-form-item
                        :style="{'margin-bottom': scope.$index == globalIndex ? '23px': '0px'}" prop="typeTpCode">
                        <el-select
                          v-if="scope.$index == globalIndex"
                          v-model="zhuankeForm.typeTpCode"
                          clearable
                          placeholder="请选择"
                          style="width: 100%"
                        >
                          <el-option v-for="(item,index) in codes.typeCodes" :key="index" :label="item.cdDesc" :value="item.cd"></el-option>
                        </el-select>
                        <div v-else class="twoLineCls"><span v-for="(item,index) in codes.typeCodes" :key="index" v-if="item.cd == scope.row.typeTpCode">{{ item.cdDesc }}</span></div>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="附件" prop="" show-overflow-tooltip >
                    <template slot-scope="scope">
                      <div style="overflow-x: auto;width: 100%">
                    <span  v-if="scope.$index == globalIndex">
                      <div v-for="(item, index) of zhuankeForm.attachIds" class="attachment-original-name">
                      <a @click="preViewAttachment(item,index,scope.$index)" style="cursor: pointer">{{item.attachmentOriginalName}}</a>
                      <el-button style="border:0px !important;cursor: pointer;" type="text" size="small" class="el-icon-close" @click="removeAttachment(scope.$index, index)"></el-button>
                    </div>
                    </span>
                        <span v-else>
                      <div v-for="(item, index) of scope.row.attachIds" class="attachment-original-name">
                      <a @click="preViewAttachment(item,index,scope.$index)" style="cursor: pointer">{{item.attachmentOriginalName}}</a>
                    </div>
                    </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="this.editFlag" align="center" prop="" label="操作" width="180" fixed="right">
                    <template slot-scope="scope">
                      <!--上传附件-->
                      <el-upload
                        v-if="scope.$index == globalIndex"
                        class="upload-btn"
                        action
                        multiple
                        :show-file-list="false"
                        fullscreen="true"
                        :accept="acceptAttachmentType"
                        :http-request="(file, fileList) => {return attachmentUpload(file, fileList, scope.$index)}"
                        :before-upload='handleBeforeUpload'
                        style="display: inline-block; margin-right: 5px">
                        <el-button style="border:0px !important;" type="text" size="small" >上传附件</el-button>
                      </el-upload>
                      <!--编辑-->
                      <el-button style="border:0px !important;" type="text" size="small" v-if="scope.$index != globalIndex" @click="handleEditClick(scope.row,scope.$index)">编辑</el-button>
                      <!--删除-->
                      <el-button style="border:0px !important;" type="text" size="small" v-if="scope.$index != globalIndex" @click="handleDeleteClick(scope.row,scope.$index)">删除</el-button>
                      <!--保存-->
                      <el-button style="border:0px !important;" type="text" size="small" v-if="scope.$index == globalIndex" @click="handleSaveClick(scope.row, scope.$index)">保存</el-button>
                      <!--取消-->
                      <el-button style="border:0px !important;" type="text" size="small" v-if="scope.$index == globalIndex" @click="handleCancelClick(scope.row, scope.$index)">取消</el-button>
                    </template>
                  </el-table-column>
                  <div v-if="(globalIndex != null ? tableData.list[globalIndex].id : true)&&this.editFlag" slot="append" style="height: 40px;text-align: center;margin: auto;font-size: 20px;padding: 8px;color: #34c5e7; cursor: pointer" @click="handleAddClick()">
                    <!--在此处添加你想要插入在表格最后一行的内容-->
                    <span>+</span>
                  </div>
                </el-table>
              </el-form>
            </div>
            <span style="float: right">
                      <el-pagination
                        layout="sizes, prev, pager, next"
                        :total="tableData.total"
                        :page-size="tableData.pageSize"
                        :page-sizes="tableData.pageSizeArray"
                        @current-change="handlePageChange"
                        @size-change="handleSizeChange"
                        :current-page="tableData.pageNum">
                    </el-pagination>
              </span>
          </div>
        </div>
      </div >
    </div>

    <!--批量导入弹窗-->
    <el-dialog style="text-align: center" title="请导入数据(该操作将刷新页面，请先保存已编辑数据)" :visible.sync="drawerVisible">
      <el-upload
        class="upload-demo"
        drag
        action
        :multiple="false"
        :http-request="fileUpload"
        :file-list="showFileList"
        :limit="1"
        accept=".xls,.xlsx"
        :before-upload='beforeUploadImport'
        :on-exceed="handleExceed">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xls/xlsx文件</div>
      </el-upload>

      <el-button style="margin-top: 20px"
                 type="primary" size="small"
                 @click="saveZhuankeByFile"
                 :loading="fileSaveBtnLoading">
        保存数据
      </el-button>

    </el-dialog>

    <!--批量导入错误数据弹窗-->
    <el-dialog style="text-align: center;" :title="'批量错误数据提示(共'+errorData.zhuankes.length+'行)'" class="error-dialog" custom-class="error-dialog" :close-on-click-modal="false" :visible.sync="errorDataVisible" @close="errorDialogClose">
      <div style="height:100%;overflow-y: auto">
        <el-table
          :data="errorData.zhuankes"
          tooltip-effect="dark"
          highlight-current-row
          height="100%"
          size="mini"
          style="width: 100%;">
          <el-table-column align="center" label="行号" width="50" prop="lineNo"></el-table-column>
          <el-table-column label="名称" prop="title"></el-table-column>
          <el-table-column align="center" label="获得时间" prop="bDate"></el-table-column>
          <el-table-column label="获奖单位性质" prop="typeTpCode"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <div class="demo-image__preview">
      <el-image
        ref="previewImg"
        :preview-src-list="attachment.attachmentsLink">
      </el-image>
    </div>

    <animation :loadingDataVisible="loadingDataVisible" :loadingText="loadingText"></animation>

  </section>
</template>

<script>
  import http from "@/utils/axios";
  import cookie from "@/utils/cookie";
  import {mapState} from "vuex";
  import {Message} from "element-ui";
  import animation from '@/components/loading/animation'
  import {ATTA_UPLOAD_COMPONENT_TYPE_STR,ATTA_FILE_SHOW_TYPE,ATTA_FILE_DOWN_TYPE,} from '@/constants/constants';
  import * as constantsRules from '@/constants/constantRules'
  import {PAGE_SIZE_ARRAY} from "@/constants/constants";
  export default {
    name: "VolunteerActivitiesList",
    components:{animation},
    data(){
      return{
        loadingDataVisible:false,   //是否显示加载动画
        title: "专科学术联盟、基地、中心信息",
        this_:this,//保存this以便filters中使用
        loadingText:null,
        zhuankeForm:{
          id : null,
          userId : "",
          title : "",
          typeTpCode : "",
          beginDate : "",
          attachIds:[],
        },
        startPickerOptions: {
          disabledDate:(t) =>{
            return t.getTime() > Date.now()
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          }]
        },
        endPickerOptions: {
          disabledDate:t =>{
            return this.zhuankeForm.beginDate ? ((t.getTime() < new Date(this.zhuankeForm.beginDate).getTime()) || (t.getTime() > Date.now()) ): (t.getTime() > Date.now())
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          }]
        },
        tableData:{
          //当前登录人
          userId: '',
          isLoading:false,
          pageNum: 1,
          pageSize: 10,
          currentPage: 1,
          pageSizeArray: PAGE_SIZE_ARRAY,
          list:[],
          total: 0,
        },
        codes:{
          typeCodes:[],
        },
        form:{
          keyword:'',
        },
        dialog:{
          editFlag:'view',
        },
        border:true,
        addAttachIndex: "",
        //附件的允许上传的类型
        acceptAttachmentType: ATTA_UPLOAD_COMPONENT_TYPE_STR,
        acceptAttachmentShowType: ATTA_FILE_SHOW_TYPE,
        acceptAttachmentDownType: ATTA_FILE_DOWN_TYPE,
        attachmentsMultipart: [],   //文件数组
        attachment:{
          attachmentsLink:[],
          //图片的类型后缀
          imagesType:['jpg','jpeg','png','gif'],
        },
        //附件的允许上传的类型
        zhuankeRules: constantsRules.ZhuankeRules,
        isEdit: false,     //是否有东西在编辑
        isCreateButton: false,   //是否出现新增按钮
        globalIndex: null,    //学历信息的全局索引
        drawerVisible: false,    //是否显示批量导入弹窗
        fileSaveBtnLoading: false,   //保存数据动画
        showFileList: [],  //附件显示的列表
        errorDataVisible: false,
        errorData:{
          zhuankes:[],
        },
        editFlag:null
      }
    },
    created(){
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      }
      // 在页面刷新时将store保存到sessionStorage里
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    },
    mounted() {
      this.editFlag=(this.$store.state.MemberManageModule.userId==null&& !['view','update'].includes(this.$store.state.MemberManageModule.type))?true:false
      this.getZhuankeCodes();

      window.onbeforeunload = e => {
        if (this.globalIndex == null) {
          return;
        }
        // 通知浏览器不要执行与事件关联的默认动作
        e.preventDefault();
        // Chrome 需要 returnValue 被设置成空字符串
        e.returnValue = '';
      };
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener("popstate", this.onBack, false);
      }
    },

    methods:{

      getZhuankeCodes(){
        let token = cookie.getCookie("token");
        http.post(window.config.api.baseUrl + '/eims-api/code/getCodes/memberZhuankeCode', {
          token: token,
          data: {}
        }).then(response => {
          if (response.data.code = '00000'){
            let codes = response.data.data;
            this.codes.typeCodes = codes['043'];
            this.queryData();
          }
        })
      },

      //规则校验
      validateFileForm() {
        let result = false;
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            result = true;
          }
        })
        return result;
      },

      tableRowClassName({row, rowIndex}) {
        if (rowIndex%2 === 0) {
          return '';
        }
        let clzz = {
          background: '#F3FDFF'+ '!important'
        };
        return clzz;
      },
      //返回
      handleBackClick(){
        this.onBack();
      },

      //分页
      handlePageChange(val) {
        this.tableData.pageNum = val;
        if (this.globalIndex != null){
          this.warnDialog(null)
        }else {
          this.queryData();
        }


      },
      handleSizeChange(val){
        this.tableData.pageSize = val;
        if (this.globalIndex != null){
          this.warnDialog(null)
        }else {
          this.queryData();
        }
      },
      closeDialog(){
        // this.dialog.isShow = false;
        this.dialog.editFlag = 'view';

      },
      handleClickSearch(){
        this.tableData.pageNum = 1;
        this.queryData();
      },
      queryData(flag){
        this.loadingDataVisible = true;
        http.post(window.config.api.baseUrl + '/eims-api/personal/data/getZhuankeList', {
          token: cookie.getCookie("token"),
          data: {
            pageNum: this.tableData.pageNum,
            pageSize: this.tableData.pageSize,
            userId:this.$store.state.MemberManageModule.userId
          }

        }).then(response => {
          if (response.data.code === '00000') {
            let obj = null
            if (flag){
              obj = JSON.parse(JSON.stringify(this.tableData.list[this.tableData.list.length-1]))
            }
            this.tableData.list = response.data.data.eimsSzyZhuankes;
            this.tableData.total = response.data.data.total;
            if (obj){
              this.zhuankeForm = JSON.parse(JSON.stringify(obj));
              this.tableData.list.push(obj);
              this.globalIndex = this.tableData.list.length - 1;
            }
          }
        }).finally(() => {
          this.loadingDataVisible = false;

        })
      },

      //编辑操作
      handleEditClick(row,index){
        if (this.globalIndex != null){
          this.warnDialog(row, index)
        }else {
          this.globalIndex = index;
          this.zhuankeForm = JSON.parse(JSON.stringify(row));
        }
      },

      //删除操作
      handleDeleteClick(row,index) {
        let that = this;
        let deleteIndex = index;
        that.$confirm('确定将专科学术联盟、基地、中心名称为' + row.honoraryTitle + '的数据删除？', {
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (row.id){
            this.loadingDataVisible = true;
            let token = cookie.getCookie("token");
            http.post(window.config.api.baseUrl + '/eims-api/personal/data/deleteZhuankeInfo', {
              token: token,
              data:{
                id: row.id
              }
            }).then((response) => {
              if (response.data.code == '00000'){
                Message.success("删除成功");
                if (deleteIndex==this.globalIndex) {
                  this.globalIndex = null;
                }else if (deleteIndex<this.globalIndex){
                  if (this.globalIndex != (this.tableData.list.length-1)){
                    this.globalIndex = (this.globalIndex - 1)
                  }
                }
                this.queryData(this.globalIndex==(this.tableData.list.length-1)?1:0);

              }
            }).finally(() => {
              this.loadingDataVisible = false;
            })
          }
        }).catch(() => {
        })
      },

      //保存操作
      handleSaveClick(row, index) {
        if(!this.validateFileForm()){
          Message.warning("编辑框校验不通过，请检查其内容！")
          return false;
        }
        Message.info("数据导入可能需要几分钟,请耐心等待")
        let that = this
        // 使用form表单的数据格式
        const paramsData = new FormData()
        // 将上传文件数组依次添加到参数paramsData中
        this.attachmentsMultipart.forEach((it, index) => {
          paramsData.append(`file`, it.file)
        });
        if (this.attachmentsMultipart.length === 0) {
          paramsData.append(`file`, null);
        }
        let jsonData = {
          token: cookie.getCookie("token"),
          data: {
            attachment: this.zhuankeForm.attachIds,
            eimsZhuanke: {
              id :this.zhuankeForm.id,
              userId : this.zhuankeForm.userId,
              title : this.zhuankeForm.title,
              typeTpCode : this.zhuankeForm.typeTpCode,
              beginDate : this.zhuankeForm.beginDate?this.moment(this.zhuankeForm.beginDate).format("YYYY-MM-DD"):null,
            }
          }
        }
        //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
        paramsData.append('data', new Blob([JSON.stringify(jsonData)], {type: "application/json"}));
        // 表单数据和文件一起上传,调用后端接口
        this.loadingDataVisible = true
        http.post(window.config.api.baseUrl + '/eims-api/personal/data/editZhuankeInfo', paramsData).then(response => {
          if(response.data.code = '00000'){
            if (row.id){
              Message.success("保存成功!");
            }else {
              Message.success("新增成功!");
            }
            this.queryData();
            this.globalIndex = null;
            Object.assign(this.$data.zhuankeForm, this.$options.data().zhuankeForm);
            this.attachmentsMultipart = [];
          }
        }).finally(() => {
          that.loadingDataVisible = false;
        })
      },

      //取消操作
      handleCancelClick(row, index){
        if (!row.id){
          this.tableData.list.splice(this.tableData.list.length-1,1);
          this.globalIndex = null;
          Object.assign(this.$data.zhuankeForm, this.$options.data().zhuankeForm);
        }else {
          this.globalIndex = null;
          Object.assign(this.$data.zhuankeForm, this.$options.data().zhuankeForm);
        }
        this.attachmentsMultipart = [];
      },

      //新增操作
      handleAddClick() {
        if (this.globalIndex != null){
          this.warnDialog();
        }else {
          this.tableData.list.push(this.zhuankeForm);
          this.globalIndex = this.tableData.list.length -1;
        }
      },

      warnDialog(row, index){
        const h = this.$createElement;
        this.$confirm('提示',{
          message: h('p', null, [
            h('p', { style: 'font-size: 18px;line-height: 40px;'}, '有内容没有保存，确定退出编辑吗？'),
            h('p', { style: 'font-size: 14px;color: #00000069;' }, '退出编辑后，更新的内容不会自动保存')
          ]),
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          /* 点击编辑按钮时 */
          if (row){
            if (!this.tableData.list[this.globalIndex].id){
              /* 第一种情况 正在新增时，点击其它的编辑按钮 */
              this.tableData.list.splice(this.tableData.list.length-1,1);
            }
            /* 第二种情况 正在编辑时,点击其它的编辑按钮*/
            this.globalIndex = index;

            this.zhuankeForm = JSON.parse(JSON.stringify(row));
            this.zhuankeForm.beginDate = new Date(this.zhuankeForm.beginDate);
            this.zhuankeForm.endDate = new Date(this.zhuankeForm.endDate);

          }else {
            if (row != undefined){
              this.globalIndex = null;
              Object.assign(this.$data.zhuankeForm, this.$options.data().zhuankeForm);
              this.queryData();
            } else {
              /* 第三种情况 正在编辑时,点击新增按钮时 */
              this.globalIndex = this.tableData.list.length;
              Object.assign(this.$data.zhuankeForm, this.$options.data().zhuankeForm);
              this.tableData.list.push(this.zhuankeForm);
            }
          }
          this.attachmentsMultipart=[];
        }).catch(() => {
        })
      },

      //上传之前的判断
      handleBeforeUpload(file) {
        let testMsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (!this.acceptAttachmentType.includes(testMsg)) {
          this.$message({
            message: '上传附件类型不合法！',
            type: 'warning',
            showClose: true
          })
          return false
        } else {
          return true
        }
      },

      //添加附件
      attachmentUpload(file, fileList,index) {
        this.zhuankeForm.attachIds.push({
          attachmentOriginalName: file.file.name
        });
        this.attachmentsMultipart.push(file);
      },

      //移除附件
      removeAttachment(listIndex,index) {
        if (!this.zhuankeForm.attachIds[index].id){
          this.attachmentsMultipart.splice(index,1);
        }
        this.zhuankeForm.attachIds.splice(index,1);
      },

      //点击查看按钮
      preViewAttachment(item,fileIndex,itemIndex){
        //准备需要查看的附件的链接,然后显示或者下载附件
        let fullName=  item.attachmentOriginalName
        //如果不是图片的格式的附件,则使用上面这种预览方式
        if(!this.attachment.imagesType.includes(fullName.substring(fullName.lastIndexOf(".") + 1))){
          //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
          //   let file = this.fileDialog.fileList[index-(this.fileDialog.tableDataList.length-this.fileDialog.fileList.length)]
          let file = this.attachmentsMultipart[fileIndex]
          if (file){
            //附件未上传预览
            this.handleView(file)
          }else{
            //附件已上传的预览
            this.handleView(this.tableData.list[itemIndex].attachIds[fileIndex])
          }
          //如果是图片则使用这种预览方式
        }else{
          //生成附件的预览链接
          this.generateAttachmentsPath(this.tableData.list[itemIndex].attachIds,fileIndex)
          if (  this.attachment.attachmentsLink.length !==0 ){
            //el-image组件的预览
            this.$refs.previewImg.showViewer = true;
          }else{
            //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
            this.handleView(this.attachmentsMultipart[fileIndex])
          }
        }
      },

      //将传来的附件生成附件的链接
      generateAttachmentsPath(attachments,index){
        let attachmentsLink=[]
        //将index这个文件放在第一个,给image组件使用的
        for (let i=index; i<attachments.length;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if (attachment.code !== undefined){
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+attachment.code);
            }
          }
        }
        if ( attachmentsLink.length === 0 ){
          this.attachment.attachmentsLink = []
          return
        }
        for (let i=0; i<index;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if(attachment.code !== undefined) {
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + attachment.code);
            }
          }
        }
        this.attachment.attachmentsLink=attachmentsLink
      },

      //准备需要查看的附件的链接,然后显示或者下载附件
      handleView(item){
        if (item.file){
          let fileType= item.file.name.substring(item.file.name.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.acceptAttachmentShowType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            elink.download = item.file.name;
          }
          elink.style.display = 'none';
          elink.target='_blank';
          // elink.href = URL.createObjectURL(new Blob([item.file.raw],{type:attaFileTypeElement}));
          elink.href = URL.createObjectURL(item.file);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          let fileType= item.attachmentOriginalName.substring(item.attachmentOriginalName.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.acceptAttachmentShowType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            http.get(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code,
              { responseType: "blob" }).then(response => {
              if (response){
                let attaFileDownTypeElement = this.acceptAttachmentDownType[fileType];
                elink.download = item.attachmentOriginalName.substring(0,item.attachmentOriginalName.lastIndexOf('.'));
                elink.style.display = 'none';
                elink.target='_blank';
                elink.href = URL.createObjectURL(new Blob([response.data],{type:attaFileDownTypeElement}));
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
              }
            }).catch(error =>{
              console.log(error)
            })
          }else {
            elink.style.display = 'none';
            elink.target='_blank'
            elink.href = window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code;
            // elink.href = URL.createObjectURL(new Blob([response],{type:attaFileTypeElement}));
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        }
      },
      //批量导入
      bulkImport(){
        if (!this.fileSaveBtnLoading) {
          this.showFileList = [];
          this.fileList = [];
        }
        this.drawerVisible = true;
      },

      //导入模板下载
      templateDown(fileName){
        const a = document.createElement('a');
        a.href = fileName;
        a.download = "专科学术联盟、基地、中心信息模板.xlsx";
        a.target = "_blank";
        a.click();

        // var pathName=window.document.location.pathname;
        // var projectName=pathName.substring(0,pathName.substr(1).indexOf('/')+1);
        // return 'http://' + window.location.host + projectName + fileName
      },

      fileUpload(file, fileList) {
        //由于组件可能存在问题 ,直接共用一个list会出现选择文件之后文件列表不显示文件名的情况
        //所以需要定义两个,一个用于显示文件名,一个用于接受文件
        this.showFileList = [];
        this.fileList = [];
        let fileInfo = {
          name: file.file.name
        }
        this.fileList.push(file);
        this.showFileList.push(fileInfo);
      },

      // 批量导入之前判断类型
      beforeUploadImport(file){
        let testMsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension1 = testMsg === 'xls'
        const extension2 = testMsg === 'xlsx'
        if (!extension1 && !extension2) {
          this.$message({
            message: '上传文件只能是xls或xlsx格式！',
            type: 'warning'
          })
          return false
        } else {
          return true
        }
      },

      handleExceed(files, fileList) {
        Message.warning({message: `只允许上传一个文件`, showClose: true});
      },

      saveZhuankeByFile() {
        if (this.showFileList.length === 0) {
          Message.error({message: "请先选择上传的文件", showClose: true});
          return
        }
        if (this.showFileList.length !== 1) {
          Message.error({message: "一次只允许上传一个文件", showClose: true});
          return
        }
        // 使用form表单的数据格式
        const paramsData = new FormData()
        // 将上传文件数组依次添加到参数paramsData中
        this.fileList.forEach((it, index) => {
          paramsData.append(`file`, it.file)
        });
        let jsonData = {
          token: cookie.getCookie("token")
        }
        // Message.info("数据导入可能需要几分钟,请耐心等待")
        //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
        paramsData.append('data', new Blob([JSON.stringify(jsonData)], {type: "application/json"}));
        // Message.success("数据导入成功");
        // this.drawerVisible = false
        // 表单数据和文件一起上传,调用后端接口
        // this.fileSaveBtnLoading = true
        this.loadingDataVisible = true
        http.post(window.config.api.baseUrl + '/eims-api/personal/data/uploadZhuankeInfo', paramsData).then(response => {
          if (response.data.code === '00000') {
            let data = response.data.data;
            Message.success("专科学术联盟、基地、中心信息批量导入操作完成")
            this.globalIndex = null;
            Object.assign(this.$data.zhuankeForm, this.$options.data().zhuankeForm);
            this.queryData()
            if (data.total != 0){
              this.errorData.zhuankes = data.eimsSzyZhuankes;
              this.errorDataVisible = true;
            }
          }
        }).finally(() => {
          this.loadingDataVisible = false;
          this.drawerVisible = false
        })
      },

      errorDialogClose(){
        Object.assign(this.$data.errorData, this.$options.data().errorData);
      },

      // 监听返回按钮的处理函数
      onBack() {
        if (this.globalIndex != null){
          const h = this.$createElement;
          this.$confirm('提示',{
            message: h('p', null, [
              h('p', { style: 'font-size: 18px;line-height: 40px;'}, '有内容没有保存，确定退出编辑吗？'),
              h('p', { style: 'font-size: 14px;color: #00000069;' }, '退出编辑后，更新的内容不会自动保存')
            ]),
            confirmButtonText: "确定",
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.globalIndex = null;
            this.$router.go(-1)
          }).catch(reason => {
            history.pushState(null, null, document.URL);
          })
        }else {
          this.$router.go(-1)
        }
      },

    },
    computed:{
      ... mapState({
        userPower: state => state.userPowerStore.userPower
      }),

    },

    watch:{
      userPower:{
        immediate:true,
        handler(newVal){
          this.superPower = this.$store.state.userPowerStore.superPower
          this.unApproveMember = this.$store.state.userPowerStore.unApproveMember
        },
      },

      "data.list.length": {
        handler(newVal, oldVal) {
          if (newVal < oldVal) {
            if (oldVal === 1){
              if (this.data.pageNum!==1){
                this.handlePageChange(this.data.pageNum - 1)
              }else {
                this.handlePageChange(1)
              }

            }
          }
        }
      },
      globalIndex:function (newVal, oldVal) {
        this.$refs['ruleForm'].resetFields();
      }
    },

    destroyed(){
      window.removeEventListener("popstate", this.onBack, false);
    },

    beforeRouteLeave (to, from, next) {
      if (this.globalIndex == null){
        next();
        return;
      }
      const h = this.$createElement;
      this.$confirm('提示',{
        message: h('p', null, [
          h('p', { style: 'font-size: 18px;line-height: 40px;'}, '有内容没有保存，确定退出编辑吗？'),
          h('p', { style: 'font-size: 14px;color: #00000069;' }, '退出编辑后，更新的内容不会自动保存')
        ]),
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        next();
      }).catch(reason => {
        next(false);
      })
    },
  }
</script>

<style scoped>
  .info-list{
    height: calc(100vh - 109px);
    margin: 20px;
    overflow: hidden;
  }
  .info-list-table-card{
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .eims-button {
    font-size: 16px;
  }
  .eims-button--text{
    border-color: transparent;
    color: #409eff;
    background: transparent;
  }
  .eims-button:focus {
    outline: none;
  }
  /deep/ .el-table .cell{
    /*line-height: unset;*/
  }

  i.icon-file-word-fill{
    color: #008dfa;
    font-size: 40px;
  }
  i.icon-PDF{
    color: #eb5e5e;
    font-size: 40px;
  }
  i.icon-file-excel-fill{
    color: #00c090;
    font-size: 40px;
  }
  i.icon-file-ppt-fill{
    color: #ff7082;
    font-size: 40px;
  }

  .info-panel-box{
    position: relative;
  }

  .info-panel-to-big{
    position: absolute;
    animation-duration: 500ms;
    animation-name: animation-to-big;
    animation-fill-mode: forwards;
  }

  @keyframes  animation-to-big {

    0%{
      width: 0;
    }

    100%{
      width: calc(100vw - 40px);

    }
  }

  .info-panel-to-small{
    position: absolute;
    animation-duration: 500ms;
    animation-name: animation-to-small;
    animation-fill-mode: forwards;
  }
  /deep/.el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-table .el-table__cell{
    vertical-align: top;
  }

  /deep/ .el-form-item__content{
    line-height: 23px;
  }

  .twoLineCls{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  /deep/ .el-table .cell{
    white-space: unset;
  }
  @keyframes  animation-to-small {

    0%{
      left: 0;
      width: calc(100vw - 40px);

    }

    100%{
      left: calc(100vw - 40px);
      width: 0;
    }

  }

  /deep/ .el-image__error{
    display: none;
  }

  .attachment-original-name:hover{
    color: #2866e3;
    text-decoration:underline;
  }
  /deep/ .error-dialog .el-dialog__body {
    /*padding: 3px 30px;*/
    overflow-y: auto;
    height: calc(100vh - 15vh - 150px);
  }
  /deep/ .el-dialog.error-dialog{
    width: 70%;
  }
  .index{
    line-height: 40px;
    position: relative;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/privateplot/memberDataList/memberSocialInfluence/CollegeBaseCentreList.vue